var TextDisplayMode;

(function (TextDisplayMode) {
  TextDisplayMode["Inline"] = "inline";
  TextDisplayMode["InlineBlock"] = "inline-block";
  TextDisplayMode["Block"] = "block";
  TextDisplayMode["Flex"] = "flex";
})(TextDisplayMode || (TextDisplayMode = {}));

var TextWeight;

(function (TextWeight) {
  TextWeight["Thin"] = "Thin";
  TextWeight["Light"] = "Light";
  TextWeight["Regular"] = "Regular";
  TextWeight["Medium"] = "Medium";
  TextWeight["Bold"] = "Bold";
  TextWeight["ExtraBold"] = "ExtraBold";
})(TextWeight || (TextWeight = {}));

var TextDecoration;

(function (TextDecoration) {
  TextDecoration["Underline"] = "underline";
  TextDecoration["Overline"] = "overline";
  TextDecoration["StrikeThrough"] = "line-through";
  TextDecoration["Solid"] = "solid";
  TextDecoration["Double"] = "double";
  TextDecoration["Dotted"] = "dotted";
  TextDecoration["Dashed"] = "dashed";
  TextDecoration["Wavy"] = "wavy";
  TextDecoration["None"] = "none";
})(TextDecoration || (TextDecoration = {}));

var TextOverflow;

(function (TextOverflow) {
  TextOverflow["Truncate"] = "truncate";
  TextOverflow["BreakWord"] = "break-word";
  TextOverflow["Wrap"] = "normal";
})(TextOverflow || (TextOverflow = {}));

export { TextDecoration, TextDisplayMode, TextOverflow, TextWeight };
